(function () {
  'use strict';

  a3_cabin_reports.constant('PaxMealEnums', (function () {

    // === Utility to create enum objects with helpers ===
    function createEnum(items) {
      return Object.assign([...items], {
        GetValue: function (title) {
          const found = this.find(e => e.title === title);
          return found ? found.value : null;
        },
        GetTitle: function (value) {
          const found = this.find(e => e.value === value);
          return found ? found.title : null;
        },
        GetDescription: function (value) {
          const found = this.find(e => e.value === value);
          return found ? found.description : null;
        }
      });
    }

    // === Enum definitions ===
    const Category = createEnum([
      { title: "Unknown", description: "Unknown", value: 0 },
      { title: "Other", description: "Other", value: 1 },
      { title: "Breakfast", description: "Breakfast", value: 2 },
      { title: "Meal", description: "Meal", value: 3 },
      { title: "Both", description: "Both", value: 4 }
    ]);

    const FlightLeg = createEnum([
      { title: "Unknown", description: "Unknown", value: 0 },
      { title: "Both", description: "Both", value: 1 },
      { title: "GO", description: "Go", value: 2 },
      { title: "RET", description: "Return", value: 3 }
    ]);

    const CabinClass = createEnum([
      { title: "Unknown", description: "Unknown", value: 0 },
      { title: "Uncategorized", description: "Uncategorized", value: 1 },
      { title: "BC", description: "Business Class", value: 2 },
      { title: "YC", description: "Economy Class", value: 3 }
    ]);

    const MealClass = createEnum([
      { title: "Unknown", description: "Unknown", value: 0 },
      { title: "OTHER", description: "Other", value: 1 },
      { title: "CREW", description: "Crew", value: 2 },
      { title: "BC SPML", description: "Business Class Special Meal", value: 3 },
      { title: "BC MEAL", description: "Business Class Standard Meal", value: 4 },
      { title: "YC SPML", description: "Economy Class Special Meal", value: 5 },
      { title: "YC MEAL", description: "Economy Class Standard Meal", value: 6 },
      { title: "SALES & SERVICE GOODS", description: "Sales & Service Goods", value: 7 }
    ]);

    // === Export all enums ===
    return {
      Category,
      FlightLeg,
      CabinClass,
      MealClass
    };
  })());
})();